import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  BUSINESS_UNIT_FIELD,
  CUSTOMER_FIELD,
  ITEMS_FIELD,
  TOTAL_PAYMENT_FIELD,
} from "constants/InvoiceTotalConstant";
import { TYPE_INVOICE_ANOTHER } from "constants/IssueInvoiceConstant";
import "flatpickr/dist/themes/material_blue.css";
import { numberWithCommas } from "helpers/utils";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { getDetailIssueInvoice } from "store/actions";
import * as yup from "yup";

const DetailInvoice = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    toggleConfirmExportModal,
    mode,
    pageView,
    typeInvoiceAnother,
  } = props;

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["issueInvoice"]);
  const { addToast } = useToasts();

  // Search modal
  const [modalSearch, setModalSearch] = useState(false);
  const toggleSearchModal = () => setModalSearch(!modalSearch);

  const [isTypeAdjustIncDesc, setIsTypeAdjustIncDesc] = useState(false);
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingCreate,
    errorCreate,
    create: issueInvoiceCreate,

    loadingEdit,
    errorEdit,
    edit: issueInvoiceEdit,

    configField,

    uploadFile,
    loadingUploadFile,
    releaseIssueInvoice,
  } = issueInvoice;

  const {
    loading: loadingDetail,
    data: detailIssueInvoice,
    error,
  } = issueInvoice.detailIssueInvoice;
  const {
    loading: loadDingEnterpriseByTaxCode,
    data: enterpriseByTaxCode,
    error: errorEnterprise,
  } = issueInvoice.enterpriseByTaxCode;

  const {
    loading: loadingConfigField,
    // businessUnitInfo,
    listCurrency,
    listVat,
    listPaymentMethod,
  } = configField;

  const schema = yup.object().shape({});
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (isOpenModal) {
      dispatch(
        getDetailIssueInvoice(
          null,
          TYPE_INVOICE_ANOTHER.INVOICE_TOTAL,
          dataDetail
        )
      );
    }
  }, [isOpenModal]);

  const modal = useRef(null);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "95%" }}
      >
        <ModalHeader toggle={toggleModal}>Thông tin hóa đơn tổng</ModalHeader>
        {loadingConfigField || loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "74vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div
                  className="custom-form-heading"
                  style={{ paddingTop: "0px" }}
                >
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN CHUNG</strong>
                </div>

                <Row className="row-cols-1 row-cols-md-2">
                  {Object.entries(BUSINESS_UNIT_FIELD).map(([key, value]) => {
                    return (
                      <React.Fragment key={key}>
                        <Col style={{ fontSize: "14px" }}>
                          <FormGroup className={`mb-3`}>
                            <Label>
                              {t(
                                `formInvoiceTotal.businessUnit.${value.field}`
                              )}
                            </Label>
                            <div style={{ borderBottom: "1px dashed #ccc" }}>
                              {detailIssueInvoice?.businessUnit[value.field] ? (
                                detailIssueInvoice?.businessUnit[value.field]
                              ) : (
                                <span style={{ fontStyle: "italic" }}>
                                  Không có thông tin
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>
                <div className="custom-form-heading mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN KHÁCH HÀNG</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {Object.entries(CUSTOMER_FIELD).map(([key, value]) => {
                    return (
                      <React.Fragment key={key}>
                        <Col style={{ fontSize: "14px" }}>
                          <FormGroup className={`mb-3`}>
                            <Label>
                              {t(`formInvoiceTotal.customer.${value.field}`)}
                            </Label>
                            <div style={{ borderBottom: "1px dashed #ccc" }}>
                              {detailIssueInvoice?.customer[value.field] ? (
                                detailIssueInvoice?.customer[value.field]
                              ) : (
                                <span style={{ fontStyle: "italic" }}>
                                  Không có thông tin
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>
                <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN DANH SÁCH HDDV</strong>
                </div>
                <div className="custom-table-border">
                  <Table className="table  table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: "20px" }}>
                          STT
                        </th>
                        {Object.entries(ITEMS_FIELD).map(([key, value]) => {
                          if (
                            dataDetail.invoice_template_code === "2" &&
                            value.field === ITEMS_FIELD.TAX_PERCENT.field
                          ) {
                            return <React.Fragment></React.Fragment>;
                          }
                          return (
                            <th
                              style={{ width: value.width }}
                              className="text-center"
                              key={key}
                            >
                              {t(`formInvoiceTotal.items.${value.field}`)}{" "}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {detailIssueInvoice?.detailPendingBill.map(
                        (field, index) => {
                          const tdStyle = {
                            display: "table-cell",
                            verticalAlign: "bottom",
                          };
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              {Object.entries(ITEMS_FIELD).map(
                                ([key, value]) => {
                                  if (
                                    dataDetail.invoice_template_code === "2" &&
                                    value.field ===
                                      ITEMS_FIELD.TAX_PERCENT.field
                                  ) {
                                    return <React.Fragment></React.Fragment>;
                                  }
                                  const data =
                                    value.type === "number"
                                      ? numberWithCommas(field[value.field])
                                      : field[value.field];
                                  return (
                                    <td style={tdStyle} key={key}>
                                      {data}
                                    </td>
                                  );
                                }
                              )}
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </Table>
                </div>
                <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN THANH TOÁN</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-1">
                  {Object.entries(TOTAL_PAYMENT_FIELD).map(([key, value]) => {
                    if (
                      dataDetail.invoice_template_code === "2" &&
                      value.field === TOTAL_PAYMENT_FIELD.TAX_TOTAL.field
                    ) {
                      return <React.Fragment></React.Fragment>;
                    }
                    let label = t(
                      `formInvoiceTotal.total_payment.${value.field}`
                    );
                    if (
                      value.field === TOTAL_PAYMENT_FIELD.TAX_TOTAL.field &&
                      detailIssueInvoice?.item.tax_type_code
                    ) {
                      label =
                        label + ` (${detailIssueInvoice?.item.tax_type_code}%)`;
                    }
                    const data =
                      value.type === "number"
                        ? numberWithCommas(
                            detailIssueInvoice?.item[value.field]
                          )
                        : detailIssueInvoice?.item[value.field];
                    return (
                      <React.Fragment key={key}>
                        <Col style={{ fontSize: "14px" }}>
                          <FormGroup className={`mb-3 d-flex`}>
                            <Label style={{ minWidth: "160px" }}>
                              {label}:
                            </Label>
                            <div
                              style={{
                                borderBottom: "1px dashed #ccc",
                                width: "100%",
                              }}
                            >
                              {detailIssueInvoice?.item[value.field] ? (
                                data
                              ) : (
                                <span style={{ fontStyle: "italic" }}>
                                  Không có thông tin
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                className="btn-label"
                type="button"
                disabled={releaseIssueInvoice.loading}
                onClick={() => {
                  toggleConfirmExportModal();
                }}
              >
                <i className="bx bx-send label-icon"></i>
                Xuất hóa đơn tổng
              </Button>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};

DetailInvoice.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  showPdfById: PropTypes.func,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  typeInvoiceAnother: PropTypes.string,
  khhdonDefault: PropTypes.string,
  pageView: PropTypes.string,
  invoiceSymbolList: PropTypes.array.isRequired,
  toggleConfirmExportModal: PropTypes.func,
};

DetailInvoice.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  pageView: "",
  invoiceSymbolList: [],
};

export default DetailInvoice;
